export default "__VITE_ASSET__6da085c2__"